import { render, staticRenderFns } from "./OrderSummaryModal.vue?vue&type=template&id=53313f82&scoped=true&"
import script from "./OrderSummaryModal.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryModal.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryModal.vue?vue&type=style&index=0&id=53313f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53313f82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53313f82')) {
      api.createRecord('53313f82', component.options)
    } else {
      api.reload('53313f82', component.options)
    }
    module.hot.accept("./OrderSummaryModal.vue?vue&type=template&id=53313f82&scoped=true&", function () {
      api.rerender('53313f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/merchant/cart_components/OrderSummaryModal.vue"
export default component.exports